import { CheckIcon, XIcon } from '@phosphor-icons/react';

import { evaluatePasswordRules } from '@/features/auth';
import { palette } from '@/lib/design-tokens/primitives';

import styles from './password-checklist.module.scss';

export function PasswordChecklist({ value }: { value: string }) {
  const rules = evaluatePasswordRules(value);
  return (
    <ul className={styles.list} aria-label="Password requirements">
      {rules.map((rule) => (
        <li
          key={rule.id}
          className={[styles.item, rule.met ? styles.met : ''].filter(Boolean).join(' ')}
          data-testid={rule.met ? 'rule-met' : 'rule-unmet'}
        >
          {rule.met ? (
            <CheckIcon size={16} fill={palette.success[900]} />
          ) : (
            <XIcon size={16} fill={palette.error[900]} />
          )}
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}
